import { getQuizDetailsQueryKey, QuizDetail } from '@cfa/pathway-fe-shared/xp';

import { queryClient } from '@/services/api';

/**
 * Subset of quiz details updated by narrow XP PATCH endpoints (not full PUT).
 *
 * TODO(PATHWAY-3918): extend as additional narrow quiz update APIs ship
 * (e.g. passing grade, metadata-only PATCH). Full quiz saves should continue
 * to refetch/hydrate details — do not route PUT through this helper.
 */
export type QuizDetailsQueryCachePatch = Pick<QuizDetail, 'name'>;

export const patchQuizDetailsQueryCache = (
  quizId: string,
  patch: QuizDetailsQueryCachePatch,
) => {
  queryClient.setQueryData<QuizDetail>(
    getQuizDetailsQueryKey({
      path: {
        quizId,
      },
    }),
    old => (old ? { ...old, ...patch } : old),
  );
};
